import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../lib/apiClient.js';
import { queryKeys } from '../../lib/queryKeys.js';
import { usageConversationDetailResponseSchema } from '../../lib/schemas.js';
import type { UsageConversationDetailResponse } from '../../lib/types.js';

export interface UsageConversationLogic {
  isLoading: boolean;
  data: UsageConversationDetailResponse | undefined;
  error: Error | null;
}

/** One conversation's cost, turn by turn. */
export const useUsageConversationLogic = (conversationId: string): UsageConversationLogic => {
  const query = useQuery<UsageConversationDetailResponse>({
    queryKey: queryKeys.usageConversation(conversationId),
    queryFn: () =>
      apiRequest<UsageConversationDetailResponse>(
        `/api/usage/conversations/${encodeURIComponent(conversationId)}`,
        undefined,
        usageConversationDetailResponseSchema,
      ),
  });
  return { isLoading: query.isLoading, data: query.data, error: query.error };
};
